/**
 * Alta ràpida de Client des d'una altra pantalla (Treballs, Pressupostos, Agenda…).
 *
 * Anada: obrirAltaClient(navigate, { tornarA, enTornar })
 * Tornada en desar: tornarDespresAltaClient(navigate, peticio, idClients)
 * Tornada en cancel·lar: cancelarAltaClient(navigate, peticio)
 * (també reobri el formulari origen via `enTornar`, sense client nou).
 *
 * `enTornar` és lliure: cada origen interpreta les seves claus
 * (p. ex. Treballs fa servir { obrirNou: true } per reobrir Nou treball).
 * No es conserva l'esborrany de la pantalla origen.
 */

export const RUTA_CLIENTS = "/dashboard/clients";
export const RUTA_TREBALLS = "/dashboard/treballs";
export const RUTA_PRESSUPOSTOS = "/dashboard/pressupostos";
export const RUTA_AGENDA = "/dashboard/agenda";

const CLAU_PETICIO = "altaClient";

export function obrirAltaClient(navigate, { tornarA, enTornar } = {}) {
  if (!navigate || !tornarA) return;
  navigate(RUTA_CLIENTS, {
    state: {
      [CLAU_PETICIO]: {
        tornarA,
        enTornar: enTornar && typeof enTornar === "object" ? enTornar : {},
      },
    },
  });
}

export function peticioAltaClient(location) {
  return location?.state?.[CLAU_PETICIO] || null;
}

export function tornarDespresAltaClient(navigate, peticio, idClients) {
  const id = Number(idClients);
  if (!navigate || !peticio?.tornarA || !id) return false;
  navigate(peticio.tornarA, {
    replace: true,
    state: {
      ...(peticio.enTornar || {}),
      client: id,
    },
  });
  return true;
}

export function cancelarAltaClient(navigate, peticio) {
  if (!navigate || !peticio?.tornarA) return false;
  navigate(peticio.tornarA, {
    replace: true,
    state: { ...(peticio.enTornar || {}) },
  });
  return true;
}

export function haDObirNouAmbClient(location) {
  return Boolean(location?.state?.obrirNou);
}
